import { createContext } from 'react'
import type { Alert, AlertOptions } from '@/types/alert.types.ts'

export interface AlertContextValue {
  alerts: Alert[]
  showAlert: (options: AlertOptions) => void
  dismissAlert: (id: string) => void
  clearAlerts: () => void
}

export const AlertContext = createContext<AlertContextValue | null>(null)
